export default __webpack_public_path__ + "static/media/arrow-top-primary.83c4efe1.svg";